import styled, { keyframes, css } from 'styled-components'

// ── paleta (coerente com as demais telas do sistema) ──────────────
const TEAL = 'var(--teal)'
const TEAL_TEXT = 'var(--teal-text, var(--teal))';
const TEAL_LIGHT = 'var(--teal-light)'
const TEAL_SOFT = 'var(--teal-soft)'
const GRAY_BG = 'var(--bg)'
const GRAY_LINE = 'var(--line)'
const GRAY_TEXT = 'var(--text-muted)'
const GREEN = 'var(--green)'
const GREEN_SOFT = 'var(--green-soft)'
const GREEN_LINE = '#cdeac8'
const RED = 'var(--red, #dc2626)'
const RED_SOFT = 'var(--red-soft)'
const RED_LINE = 'var(--red)'
const AMBER = 'var(--amber, #d97706)'

const bp = {
    desktop: '1024px',
    tablet: '768px',
    mobile: '540px',
    small: '380px'
}

const expand = keyframes`
    from { opacity: 0; transform: translateY(-6px); }
    to   { opacity: 1; transform: translateY(0); }
`

const shimmer = keyframes`
    0%   { background-position: -400px 0; }
    100% { background-position: 400px 0; }
`

export const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    background: ${GRAY_BG};
    padding: 16px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;

    @media (max-width: ${bp.tablet}) { padding: 12px; }
    @media (max-width: ${bp.mobile}) { padding: 8px; }
`

export const ContainerDivs = styled.div`
    width: 100%;
    max-width: 860px;
    display: flex;
    flex-direction: column;
    gap: 14px;

    @media (max-width: ${bp.mobile}) { gap: 10px; }
`

/* ── Header ─────────────────────────────────────────────────────── */

export const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 18px 20px;
    background: ${TEAL};
    color: #fff;
    border-radius: 14px;
    box-shadow: 0 6px 18px rgba(0, 62, 79, 0.18);

    @media (max-width: ${bp.mobile}) { padding: 14px 16px; border-radius: 12px; }
`

export const BackButton = styled.button`
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    border: none;
    background: rgba(255, 255, 255, 0.14);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background .15s ease;

    &:hover { background: rgba(255, 255, 255, 0.26); }
    &:focus-visible { outline: 2px solid #fff; outline-offset: 2px; }
`

export const HeaderInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    flex: 1;
`

export const Title = styled.h1`
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0.2px;

    @media (max-width: ${bp.mobile}) { font-size: 17px; }
`

export const Subtitle = styled.span`
    font-size: 12px;
    font-weight: 600;
    opacity: 0.85;
    text-transform: uppercase;
    letter-spacing: 0.4px;
`

export const HeaderBadge = styled.span`
    flex-shrink: 0;
    background: ${({ $tone }) =>
        $tone === 'done' ? 'rgba(227,243,225,0.22)'
            : $tone === 'pending' ? 'rgba(251,236,234,0.22)'
                : 'rgba(255,255,255,0.18)'};
    color: #fff;
    font-size: 12px;
    padding: 8px 14px;
    border-radius: 999px;
    font-weight: 700;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    gap: 6px;
`

/* ── Barra de progresso (elemento-assinatura) ──────────────────── */

export const ProgressCard = styled.div`
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 14px;
    padding: 16px 18px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    @media (max-width: ${bp.mobile}) { padding: 14px; border-radius: 12px; }
`

export const ProgressTop = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 10px;
`

export const ProgressLabel = styled.span`
    font-size: 13px;
    font-weight: 600;
    color: ${GRAY_TEXT};
`

export const ProgressValue = styled.span`
    font-size: 22px;
    font-weight: 800;
    color: ${TEAL_TEXT};
    font-variant-numeric: tabular-nums;

    small {
        font-size: 13px;
        font-weight: 600;
        color: ${GRAY_TEXT};
        margin-left: 4px;
    }
`

export const ProgressTrack = styled.div`
    width: 100%;
    height: 10px;
    border-radius: 999px;
    background: ${TEAL_SOFT};
    overflow: hidden;
`

export const ProgressFill = styled.div`
    height: 100%;
    width: ${({ $pct }) => `${$pct}%`};
    border-radius: 999px;
    background: linear-gradient(90deg, ${GREEN} 0%, ${TEAL_LIGHT} 100%);
    transition: width .5s cubic-bezier(.4, 0, .2, 1);
`

/* ── Toolbar / busca ────────────────────────────────────────────── */

export const Toolbar = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 12px;
    padding: 10px 12px;

    @media (max-width: ${bp.mobile}) { padding: 8px 10px; }
`

export const DateInput = styled.input`
    flex: 1;
    min-width: 150px;
    border: 1px solid ${GRAY_LINE};
    background: var(--surface);
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 14px;
    color: ${TEAL_TEXT};
    outline: none;
    transition: border-color .15s ease, box-shadow .15s ease;

    &:focus {
        border-color: ${TEAL_LIGHT};
        box-shadow: 0 0 0 3px rgba(10, 90, 115, 0.10);
    }

    @media (max-width: ${bp.mobile}) { min-height: 44px; font-size: 16px; }
`

export const ChipButton = styled.button`
    border: 1px solid ${({ $active }) => ($active ? TEAL_LIGHT : GRAY_LINE)};
    background: ${({ $active }) => ($active ? TEAL_SOFT : 'var(--surface)')};
    color: ${TEAL_TEXT};
    border-radius: 8px;
    padding: 9px 14px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: background .12s ease, border-color .12s ease;

    &:hover { background: ${TEAL_SOFT}; }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }
    &:disabled { opacity: .5; pointer-events: none; }

    @media (max-width: ${bp.mobile}) { min-height: 44px; }
`

export const AddButton = styled.button`
    border: none;
    background: ${TEAL};
    color: #fff;
    border-radius: 8px;
    padding: 9px 16px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: filter .12s ease, transform .12s ease;

    &:hover { filter: brightness(1.1); transform: translateY(-1px); }
    &:active { transform: translateY(0); }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }

    @media (max-width: ${bp.mobile}) { min-height: 44px; flex: 1; justify-content: center; }
`

/* ── Seção (Realizadas / Pendentes) ────────────────────────────── */

export const Section = styled.section`
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 14px;
    overflow: hidden;

    @media (max-width: ${bp.mobile}) { border-radius: 12px; }
`

export const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 14px 18px;
    background: ${({ $tone }) => ($tone === 'pending' ? RED_SOFT : GREEN_SOFT)};
    border-bottom: 1px solid ${({ $tone }) => ($tone === 'pending' ? RED_LINE : GREEN_LINE)};

    @media (max-width: ${bp.mobile}) { padding: 12px 14px; }
`

export const SectionTitle = styled.span`
    font-weight: 700;
    font-size: 14px;
    color: ${({ $tone }) => ($tone === 'pending' ? RED : GREEN)};
    display: flex;
    align-items: center;
    gap: 8px;

    @media (max-width: ${bp.mobile}) { font-size: 13px; }
`

export const CountPill = styled.span`
    background: ${({ $tone }) => ($tone === 'pending' ? RED : GREEN)};
    color: #fff;
    font-size: 11px;
    padding: 3px 9px;
    border-radius: 999px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
`

export const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px;

    @media (max-width: ${bp.mobile}) { padding: 8px; gap: 6px; }
`

// item base
const itemBase = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 10px;
    cursor: pointer;
    border: 1px solid transparent;
    text-align: left;
    width: 100%;
    background: var(--surface);
    transition: transform .12s ease, box-shadow .12s ease, background .15s ease;
    animation: ${expand} .18s ease;

    &:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0,0,0,.06); }
    &:active { transform: translateY(0); }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }

    @media (max-width: ${bp.mobile}) { padding: 13px 14px; }
`

export const EmpDone = styled.button`
    ${itemBase}
    background: ${GREEN_SOFT};
    border-color: ${GREEN_LINE};
    &:hover { background: #d6efd2; }
`

export const EmpPending = styled.button`
    ${itemBase}
    background: ${RED_SOFT};
    border-color: ${RED_LINE};
    &:hover { background: #f7ddd9; }
`

/* chamada feita em dia que NÃO é letivo → laranja, para verificar */
export const EmpWarn = styled.button`
    ${itemBase}
    background: var(--orange-soft, #fff1e0);
    border-color: var(--orange, #e67e22);
    &:hover { background: #ffe4c4; }
`

export const WarnTag = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    font-size: 12px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    text-align: right;
    color: var(--orange, #d35400);
`

export const DateText = styled.span`
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 15px;
    font-weight: 600;
    color: ${TEAL_TEXT};
    font-variant-numeric: tabular-nums;

    @media (max-width: ${bp.small}) { font-size: 14px; }
`

export const WeekdayTag = styled.span`
    font-size: 11px;
    font-weight: 600;
    color: ${GRAY_TEXT};
    text-transform: capitalize;
`

/* compat com import antigo <Span> */
export const Span = DateText

/* ── Estado vazio ───────────────────────────────────────────────── */

export const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 26px 18px;
    text-align: center;
    color: ${GRAY_TEXT};
    font-size: 14px;

    strong { color: ${TEAL_TEXT}; font-weight: 700; }

    @media (max-width: ${bp.mobile}) { padding: 20px 14px; }
`

export const ShowMoreButton = styled.button`
    background: transparent;
    color: ${TEAL_LIGHT};
    border: none;
    border-top: 1px solid ${GRAY_LINE};
    padding: 13px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    width: 100%;
    transition: background .12s ease;

    &:hover { background: ${GRAY_BG}; }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: -2px; }
`

/* ── Skeleton ───────────────────────────────────────────────────── */

const skeletonBase = css`
    background: linear-gradient(90deg, var(--skel-a) 0%, var(--skel-b) 50%, var(--skel-a) 100%);
    background-size: 800px 100%;
    animation: ${shimmer} 1.3s linear infinite;
    border-radius: 8px;
`

export const SkeletonLine = styled.div`
    ${skeletonBase}
    height: ${({ $h }) => $h || '14px'};
    width: ${({ $w }) => $w || '100%'};
    margin: 4px 0;
`

export const SkeletonCard = styled.div`
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`

/* ── Voltar (rodapé) ────────────────────────────────────────────── */

export const ToGoBack = styled.div`
    display: flex;
    gap: 6px;
    justify-content: center;
    align-items: center;
    padding: 14px 8px;
    cursor: pointer;
    user-select: none;
    color: ${GRAY_TEXT};
    font-size: 14px;
    min-height: 44px;
    &:hover { color: ${TEAL_TEXT}; }
`

export const SignMessageButtonText = styled.span``
export const SignMessageButtonTextBold = styled.span`
    font-weight: 700;
    color: ${TEAL_TEXT};
    margin-left: 4px;
`

/* ── Modal de acesso restrito ──────────────────────────────────── */

export const ModalOverlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(3px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 16px;
    animation: ${expand} .15s ease;

    @media (max-width: ${bp.mobile}) { align-items: flex-end; padding: 8px; }
`

export const ModalContent = styled.div`
    background: var(--surface);
    padding: 24px;
    border-radius: 14px;
    max-width: 420px;
    width: 100%;
    text-align: center;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);

    h3 { margin: 0 0 10px; color: ${AMBER}; font-size: 18px; }
    p  { margin: 0; color: ${GRAY_TEXT}; font-size: 14px; line-height: 1.55; }

    @media (max-width: ${bp.mobile}) {
        border-radius: 14px 14px 0 0;
        padding: 20px 16px;
        max-width: 100%;
    }
`

export const ModalButton = styled.button`
    margin-top: 18px;
    background: ${TEAL};
    color: #fff;
    border: none;
    padding: 11px 22px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    min-height: 44px;
    transition: filter .12s ease;

    &:hover { filter: brightness(1.1); }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }
`